export const IDLE_SESSION_TIMEOUT_IN_MILLISECONDS = 1000 * 60 * 15;
import { CheckCircle1, Alerts2, FaxOutlined} from '@mediwareinc/wellsky-dls-react-icons';


export const ROLE_RESOURCE_TEXT = {
  USER: {
    title: "Users",
    subtitle: "Manage other users within the same organization.",
  },
  USER_GROUP: {
    title: "User Groups",
    subtitle: "Manage other user groups within the same organization.",
  },
  USER_TASK: {
    title: "User Tasks",
    subtitle: "Access to User Task module.",
  },
  ROLES: {
    title: "Roles",
    subtitle: "Manage roles within the organization.",
  },
  ORGANIZATION: {
    title: "Organization",
    subtitle: "Manage organization profile details.",
  },
  ORG_INTERVENTIONS: {
    title: "Interventions",
    subtitle: "Manage organization's interventions.",
    parent: "ORGANIZATION",
  },
  ORG_AUTHS: {
    title: "Authorizations",
    subtitle: "Manage intervention's authorizations.",
    parent: "ORGANIZATION",
  },
  ORG_TASKS: {
    title: "Tasks",
    subtitle: "Manage intervention's tasks.",
    parent: "ORGANIZATION",
  },
  PATIENT: {
    title: "Patient",
    subtitle: "Manage patient's profile details.",
  },
  PATIENT_ORDER_PERSONAL_CARE: {
    title: "Order Personal Care",
    subtitle: "Order personal care for a patient.",
    parent: "PATIENT",
  },
  PATIENT_INTERVENTIONS: {
    title: "Interventions",
    subtitle: "Manage patient's intervention.",
    parent: "PATIENT",
  },
  PATIENT_AUTHS: {
    title: "Authorizations",
    subtitle: "Manage patient's authorization(s).",
    parent: "PATIENT",
  },
  PATIENT_TASKS: {
    title: "Tasks",
    subtitle: "Manage patient's task(s).",
    parent: "PATIENT",
  },
  PATIENT_DOCS: {
    title: "Documents",
    subtitle: "Manage patient's Document(s).",
    parent: "PATIENT",
  },
  PATIENT_OBSERVATIONS: {
    title: "Observations",
    subtitle: "Manage patient's Observation(s).",
    parent: "PATIENT",
  },
  REPORTS: {
    title: "Reports",
    subtitle: "Access to Reports module.",
  },
};

export const POLICY_DEFAULTS = () => [
  {
    resource: "USER",
    action: "DISABLED",
    effect: "ALLOW",
  },
  {
    resource: "USER_GROUP",
    action: "DISABLED",
    effect: "ALLOW",
  },
  {
    resource: "USER_TASK",
    action: "DISABLED",
    effect: "ALLOW",
  },
  {
    resource: "ROLES",
    action: "DISABLED",
    effect: "ALLOW",
  },
  {
    resource: "ORGANIZATION",
    action: "DISABLED",
    effect: "ALLOW",
  },
  {
    resource: "ORG_INTERVENTIONS",
    action: "DISABLED",
    effect: "ALLOW",
  },
  {
    resource: "ORG_AUTHS",
    action: "DISABLED",
    effect: "ALLOW",
  },
  {
    resource: "ORG_TASKS",
    action: "DISABLED",
    effect: "ALLOW",
  },
  {
    resource: "PATIENT",
    action: "DISABLED",
    effect: "ALLOW",
  },
  {
    resource: "PATIENT_ORDER_PERSONAL_CARE",
    action: "DISABLED",
    effect: "ALLOW",
  },
  {
    resource: "PATIENT_INTERVENTIONS",
    action: "DISABLED",
    effect: "ALLOW",
  },
  {
    resource: "PATIENT_AUTHS",
    action: "DISABLED",
    effect: "ALLOW",
  },
  {
    resource: "PATIENT_TASKS",
    action: "DISABLED",
    effect: "ALLOW",
  },
  {
    resource: "PATIENT_DOCS",
    action: "DISABLED",
    effect: "ALLOW",
  },
  {
    resource: "PATIENT_OBSERVATIONS",
    action: "DISABLED",
    effect: "ALLOW",
  },
  {
    resource: "REPORTS",
    action: "DISABLED",
    effect: "ALLOW",
  }
];

export const STATE_HASH = {
  AL: "Alabama",
  AK: "Alaska",
  AS: "American Samoa",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District Of Columbia",
  FM: "Federated States Of Micronesia",
  FL: "Florida",
  GA: "Georgia",
  GU: "Guam",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MH: "Marshall Islands",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  MP: "Northern Mariana Islands",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PW: "Palau",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VI: "Virgin Islands",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
  DC: "Washington DC",
};

export const ORG_TYPES = {
  covid_disp: "Covid Contact Dispatcher",
  covid_trace: "Covid Contact Tracer",
  practitioners: "Practitioners",
  prov: "Healthcare Provider",
  dept: "Hospital Department",
  team: "Organizational Team",
  govt: "Government",
  ins: "Insurance Company",
  edu: "Educational Institution",
  relg: "Religious Institution",
  crs: "Clinical Research Sponsor",
  cg: "Community Group",
  bus: "Non-Healthcare Business or Corporation",
  net: "Network",
  wellsky_ops: "WellSky Ops",
  other: "Other",
};

export const SERVICE_TYPES = {
  home_healthcare: "Home Healthcare",
  home_health: "Home Health",
  personal_care: "Personal Care",
  hospice: "Hospice",
  physical_therapy: "Physical Therapy",
  covid_case: "COVID Case",
  covid_contact: "COVID Contact",
  practitioners: "Practitioners",
};

export const EPISODE_OF_CARE_STATUS = [
  { value: "FINISHED", display: "Finished" },
  { value: "UNKNOWN", display: "Unknown" },
  { value: "PLANNED", display: "Planned" },
  { value: "WAITLIST", display: "Waitlist" },
  { value: "ACTIVE", display: "Active" },
  { value: "ON_HOLD", display: "On Hold" },
  { value: "CANCELLED", display: "Cancelled" },
  { value: "ENTERED_IN_ERROR", display: "Entered-in-Error" },
];

export const AUTHORIZED_UNITS_OF_TIME_MAP = [
  { value: "PERIOD_PER_DAY", display: "Day" },
  { value: "PERIOD_PER_WEEK", display: "Week" },
  { value: "PERIOD_PER_MONTH", display: "Month" },
  { value: "PERIOD_PER_2_WEEKS", display: "2 Weeks" },
  { value: "PERIOD_PER_YEAR", display: "Year" },
  { value: "PERIOD_PER_AUTHORIZATION", display: "Authorization" },
  { value: "PERIOD_PER_QUARTER", display: "Quarter" },
];

export const AUTHORIZATION_UNIT_TYPES = [
  { value: "BASED_ON_HOURS", display: "Hours" },
  { value: "BASED_ON_VISITS", display: "Visits" },
];

export const AUTHORIZATION_UNIT_TYPES_MAP = {
  BASED_ON_HOURS: "Hours",
  BASED_ON_VISITS: "Visits",
};

export const AUTHORIZATION_UNIT_TYPES_SINGULAR = [
  { value: "BASED_ON_HOURS", display: "Hour" },
  { value: "BASED_ON_VISITS", display: "Visit" },
];

export const AUTHORIZATION_UNIT_TYPES_SINGULAR_MAP = {
  BASED_ON_HOURS: "Hour",
  BASED_ON_VISITS: "Visit",
};

export const AUTHORIZATION_STATUS = [
  { value: "ACTIVE", display: "Active" },
  { value: "CANCELLED", display: "Cancelled" },
  { value: "DRAFT", display: "Draft" },
  { value: "ENTERED_IN_ERROR", display: "Entered-in-Error" },
];

export const AUTHORIZATION_STATUS_MAP = {
  ACTIVE: "Active",
  CANCELLED: "Cancelled",
  DRAFT: "Draft",
  ENTERED_IN_ERROR: "Entered-in-Error",
};

export const CLAIM_TYPES = [
  { value: "INSTITUTIONAL", display: "Institional" },
  { value: "ORAL", display: "Oral" },
  { value: "PHARMACY", display: "Pharmacy" },
  { value: "PROFESSIONAL", display: "Professional" },
  { value: "VISION", display: "Vision" },
];

export const CLAIM_PRIORITY = [
  { value: "STAT", display: "Stat" },
  { value: "NORMAL", display: "Normal" },
  { value: "DEFERRED", display: "Deferred" },
];

export const UNITS_OF_TIME = [
  { value: "SECOND", display: "Second" },
  { value: "MINUTE", display: "Minute" },
  { value: "HOUR", display: "Hour" },
  // { value: 'PERIOD_PER_DAY', display: 'Day' },
  // { value: 'PERIOD_PER_WEEK', display: 'Week' },
  // { value: 'PERIOD_PER_MONTH', display: 'Month' },
  // { value: 'PERIOD_PER_YEAR', display: 'Year' },
];

export const UNITS_OF_TIME_MAP = {
  SECOND: "Second",
  MINUTE: "Minute",
  HOUR: "Hour",
  DAY: "Day",
  WEEK: "Week",
  MONTH: "Month",
  YEAR: "Year",
};

export const SHIFT_HOURS = [
  { optionVal: "7to12", display: "7am to 12pm", dbVal: { low: 7, high: 12 } },
  { optionVal: "12to5", display: "Noon to 5pm", dbVal: { low: 12, high: 17 } },
  { optionVal: "5to11", display: "5pm to 11pm", dbVal: { low: 17, high: 23 } },
  { optionVal: "11to7", display: "11pm to 7am", dbVal: { low: 23, high: 7 } },
];

export const ADL_TYPES = [
  { value: "AMBULATION_TRANSFER", display: "Ambulation & Transfer" },
  { value: "BATHING_SHOWERING", display: "Bathing" },
  { value: "DRESSING_GROOMING", display: "Dressing & Grooming" },
  { value: "EATING", display: "Eating" },
  { value: "TOILETING", display: "Toileting" },
  { value: "CONTINENCE", display: "Continence" },
  { value: "HOUSEWORK", display: "Housework" },
  { value: "LAUNDRY", display: "Laundry" },
  { value: "MONEY_AND_BILLS", display: "Money and Bills" },
  { value: "MEDICATION", display: "Medication" },
  { value: "PET_CARE", display: "Pet Care" },
  { value: "PREPARING_MEALS", display: "Preparing Meals" },
  { value: "SHOPPING", display: "Shopping" },
  { value: "TRAVELING", display: "Traveling" },
  { value: "USING_TELEPHONE", display: "Using Telephone" },
];

export const DAYS_OF_THE_WEEK = [
  { value: "MON", display: "Mon", shortDisplay: "M" },
  { value: "TUE", display: "Tue", shortDisplay: "T" },
  { value: "WED", display: "Wed", shortDisplay: "W" },
  { value: "THUR", display: "Thur", shortDisplay: "Th" },
  { value: "FRI", display: "Fri", shortDisplay: "F" },
  { value: "SAT", display: "Sat", shortDisplay: "S" },
  { value: "SUN", display: "Sun", shortDisplay: "Su" },
];

export const PATIENT_STATUS_COLOR_MAP = {
  NEW: "gold",
  NEEDS_REVIEW: "orange",
  IN_REVIEW: "blue",
  AVAILABLE: "purple",
  CLAIMED: "green",
  REFERRAL_FORM_SUBMITTED: "blue",
  INITIAL_CALL_COMPLETED: "green",
  ASSESSMENT_SCHEDULED: "orange",
  ASSESSMENT_COMPLETED: "green",
  SEEKING_FUNDING: "orange",
  DECLINED: "red",
  ESCALATED: "red",
  ACTIVE: "geekblue",
  ERROR: "red",
  PATIENT_DECLINED: "red",
  LOST: "blue",
  FAILED_TO_IMPORT: "red",
};

export const COVID_STATUS_COLOR_MAP = {
  UNKNOWN: "gray",
  CASE: "red",
  CONTACT: "orange",
  RECOVERED: "purple",
  CLEAR: "green",
};

export const COVID_STATUS_TEXT_MAP = {
  UNKNOWN: "UNKNOWN",
  CASE: "CASE",
  CONTACT: "CONTACT",
  RECOVERED: "RECOVERED",
  CLEAR: "CLEAR",
};

export const PATIENT_STATUS_TEXT_MAP = {
  NEW: "NEW",
  NEEDS_REVIEW: "NEEDS REVIEW",
  IN_REVIEW: "IN REVIEW",
  AVAILABLE: "AVAILABLE",
  CLAIMED: "CLAIMED",
  REFERRAL_FORM_SUBMITTED: "REFERRAL FORM SUBMITTED",
  INITIAL_CALL_COMPLETED: "INITIAL CALL COMPLETED",
  ASSESSMENT_SCHEDULED: "ASSESSMENT SCHEDULED",
  ASSESSMENT_COMPLETED: "ASSESSMENT COMPLETED",
  SEEKING_FUNDING: "SEEKING FUNDING",
  DECLINED: "AGENCY DECLINED",
  ESCALATED: "ESCALATED",
  ACTIVE: "ACTIVE",
  ERROR: "ERROR",
  PATIENT_DECLINED: "PATIENT DECLINED",
  LOST: "LOST",
  FAILED_TO_IMPORT: "FAILED TO IMPORT",
  CLAIM_INITIATED: "CLAIM INITIATED",
  POSSIBLE_MATCH: "POSSIBLE MATCH",
  POSSIBLE_DUPLICATE: "POSSIBLE DUPLICATE",
};

export const SERVICE_REQUEST_CATEGORY_CODE_MAP = {
  home_healthcare: "Home Health",
  personal_care: "Personal Care",
};

export const PATIENT_ROUTING_STATUS_COLOR_MAP = {
  NOT_ROUTED: null,
  ROUTING: "orange",
  ROUTED: "green",
  NO_MATCHING_AGENCIES: "orange",
  NO_MATCHING_AGENCIES_ZIP: "red",
  NO_MATCHING_AGENCIES_INTERVENTION: "red",
};

export const PATIENT_ROUTING_STATUS_STRING_MAP = {
  NOT_ROUTED: "NOT REQUESTED",
  ROUTING: "ROUTING...",
  ROUTED: "REQUESTED",
  NO_MATCHING_AGENCIES: "FAILED TO ROUTE",
  NO_MATCHING_AGENCIES_ZIP: "MISSING ZIP",
  NO_MATCHING_AGENCIES_INTERVENTION: "MISSING INTERVENTION",
};

export const USER_TASK_STATUS_MAP = {
  DEFAULT: { color: "orange", label: "Unknown" },
  COMPLETE: { color: "green", label: "Complete" },
  COMPLETED: { color: "green", label: "Completed" },
  CREATED: { color: "orange", label: "Created" },
  WONT_COMPLETE: { color: "purple", label: "Won't Complete" },
  CANCELLED: { color: "red", label: "Cancelled" },
  FAILED: { color: "red", label: "Failed" },
  IN_PROGRESS: { color: "blue", label: "In-Progress" },
};

export const TASKLOG_STATUS_MAP = {
  COMPLETE: { color: "#4caf50", icon: "check-square" },
  INCOMPLETE: { color: "yellow", icon: "warning" },
  SKIPPED: { color: "red", icon: "close-circle" },
};

export const CARELOG_STATUS_MAP = {
  SCHEDULED: { color: "#4caf50", icon: "check-square" },
  NOT_SCHEDULED: { color: "yellow", icon: "warning" },
  COMPLETE: { color: "#4caf50", icon: "check-square" },
  NOT_COMPLETE: { color: "yellow", icon: "warning" },
  CANCELLED_BY_CLIENT: { color: "yellow", icon: "warning" },
  CANCELLED_BY_CAREGIVER: { color: "yellow", icon: "warning" },
  CAREGIVER_NO_SHOW: { color: "yellow", icon: "warning" },
  TENTATIVE: { color: "yellow", icon: "warning" },
  ATTENTION_REQUIRED: { color: "yellow", icon: "warning" },
  CAREGIVER_UNAVAILABILITY: { color: "yellow", icon: "warning" },
  OPEN_SHIFT: { color: "yellow", icon: "warning" },
  IN_PROGRESS: { color: "yellow", icon: "warning" },
  PENDING_CONFIRMATION: { color: "yellow", icon: "warning" },
};

export const ENROLLMENT_STATUS_MAP = {
  INITIATED: { color: "grey", label: "Initiated" },
  SIGNED_UP: { color: "blue", label: "Signed Up" },
  ENROLLED: { color: "orange", label: "Enrolled" },
  ENABLED: { color: "green", label: "Enabled" },
  DELETED: { color: "red", label: "Deleted" },
};

export const CONTACT_RELATION_TYPES = {
  FATHER: "Father",
  MOTHER: "Mother",
  FATHER_IN_LAW: "Father-in-law",
  MOTHER_IN_LAW: "Mother-in-law",
  SPOUSE: "Spouse",
  BROTHER: "Brother",
  SISTER: "Sister",
  SON: "Son",
  SON_IN_LAW: "Son-in-law",
  DAUGHTER: "Daughter",
  DAUGHTER_IN_LAW: "Daughter-in-law",
  GRANDSON: "Grandson",
  GRANDDAUGHTER: "Granddaughter",
  OTHER_RELATIONSHIP: "Other",
  DOCTOR: "Doctor",
  NURSE: "Nurse",
  SOCIAL_WORKER: "Social Worker",
  DISCHARGE_PLANNER: "Discharge Planner",
  Geriatric_Care_Manager: "Geriatric Care Manager (GCM) ",
  FAMILY: "Family",
  FRIEND: "Friend",
  INSURANCE_COMPANY: "Insurance Company",
  MEDICAL_PROFESSIONAL: "Medical Professional",
  NEIGHBOR: "Neighbor",
  OTHER: "Other",
};

export const PATIENT_CONTACT_RELATION_TYPES = {
  PRIMARY_CONTACT: "Primary Contact",
  PCP: "Primary Care Provider",
  FAMILY_PRACTICE_PHYSICIAN: "Family Practice Physician",
  GENERAL_PRACTICE_PHYSICIAN: "General Practice Physician",
  INTERNAL_MEDICINE_PHYSICIAN: "Internal Medicine Physician",
  GENERAL_MEDICINE_PHYSICIAN: "General Medicine Physician",
  SPECIALIST_PHYSICIAN: "Specialist Physician",
  OTHER_PHYSICIAN: "Other Physician",
  OTHER_HEALTH_CARE_PROVIDER: "Other Health Care Provider",
  INSURANCE_COMPANY: "Insurance Company",
  FAMILY_MEMBER: "Family Member",
  FRIEND: "Friend",
  NEIGHBOR: "Neighbor",
  RESPONSIBLE_PARTY: "Responsible Party",
  APPOINTED_REPRESENTATIVE: "Appointed Representative",
  ATTORNEY_IN_FACT: "Attorney-In-Fact",
  HEALTHCARE_PROXY: "Healthcare Proxy",
  PARENT: "Parent",
  GUARDIAN: "Guardian",
  PHARMACY: "Pharmacy",
  OTHER: "Other"
}

export const VISIT_TYPES = {
  IN_PERSON: "in-person",
  TELEPHONE: "telephone",
};

export const GENDER = {
  M: "Male",
  F: "Female",
  TF: "Trans-Female",
  TM: "Trans-Male",
  GNC: "Gender Non-Conforming",
  U: "Unknown",
  O: "Other",
};

export const GENDERS = {
  M: "Male",
  F: "Female",
  O: "Other",
  U: "Undetermined",
};

export const LANGUAGES = {
  AR: "Arabic",
  BN: "Bengali",
  CS: "Czech",
  DA: "Danish",
  DE: "German",
  DE_AT: "German (Austria)",
  DE_CH: "German (Switzerland)",
  DE: "German",
  DE_DE: "German (Germany)",
  EL: "Greek",
  EN: "English",
  EN_AU: "English (Australia)",
  EN_CA: "English (Canada)",
  EN_GB: "English (Great Britain)",
  EN_IN: "English (India)",
  EN_NZ: "English (New Zeland)",
  EN_SG: "English (Singapore)",
  EN_US: "English (United States)",
  ES: "Spanish",
  ES_AR: "Spanish (Argentina)",
  ES_ES: "Spanish (Spain)",
  ES_UY: "Spanish (Uruguay)",
  FI: "Finnish",
  FR: "French",
  FR_BE: "French (Belgium)",
  FR_CH: "French (SWITZERLAND)",
  FR_FR: "French (France)",
  FY: "Frysian",
  FY_NL: "Frysian (Netherlands)",
  HI: "Hindi",
  HR: "Croatian",
  IT: "Italian",
  IT_CH: "Italian (Switzerland)",
  IT_IT: "Italian (Italy)",
  JA: "Japanese",
  KO: "Korean",
  NL: "Dutch",
  NL_BE: "Dutch (Belgium)",
  NL_NL: "Dutch (Netherlands)",
  NO: "Norwegian",
  NO_NO: "Norwegian (Norway)",
  PA: "Punjabi",
  PL: "Polish",
  PT: "Portuguese",
  PT_BR: "Portuguese (Brazil)",
  RU: "Russian",
  RU_RU: "Russian (Russia)",
  SR: "Serbian",
  SR_RS: "Serbian (Serbia)",
  SV: "Swedish",
  SV_SE: "Swedish (Sweden)",
  TE: "Telegu",
  ZH: "Chinese",
  ZH_CN: "Chinese (China)",
  ZH_HK: "Chinese (Hong Kong)",
  ZH_SG: "Chinese (Singapore)",
  ZH_TW: "Chinese (Taiwan)",
};

export const RESERVATION_STATUS_MAP = {
  NEW: "NEW",
  NEEDS_REVIEW: "NEEDS_REVIEW",
  IN_REVIEW: "IN_REVIEW",
  AVAILABLE: "AVAILABLE",
  CLAIMED: "CLAIMED",
  REFERRAL_FORM_SUBMITTED: "REFERRAL FORM SUBMITTED",
  INITIAL_CALL_COMPLETED: "INITIAL CALL COMPLETED",
  ASSESSMENT_SCHEDULED: "ASSESSMENT SCHEDULED",
  ASSESSMENT_COMPLETED: "ASSESSMENT COMPLETED",
  SEEKING_FUNDING: "SEEKING FUNDING",
  DECLINED: "DECLINED",
  PATIENT_DECLINED: "PATIENT_DECLINED",
  ESCALATED: "ESCALATED",
  ACTIVE: "ACTIVE",
  ERROR: "ERROR",
  LOST: "LOST",
  POSSIBLE_DUPLICATE: "POSSIBLE_DUPLICATE",
};

export const AGENCY_REJECTION_CHOICES = [
  {
    key: "agencyOnHold",
    title: "On Hold",
    status: RESERVATION_STATUS_MAP.DECLINED,
  },
  {
    key: "agencyHospFirst",
    title: "Hospitalization – First Admission",
    status: RESERVATION_STATUS_MAP.DECLINED,
  },
  {
    key: "agencyHospReadmission",
    title: "Hospitalization – Readmission",
    status: RESERVATION_STATUS_MAP.DECLINED,
  },
  {
    key: "agencyDeceased",
    title: "Deceased",
    status: RESERVATION_STATUS_MAP.DECLINED,
  },
  {
    key: "agencyStaffing",
    title: "Staffing",
    status: RESERVATION_STATUS_MAP.DECLINED,
  },
  {
    key: "agencyComplexity",
    title: "Patient complexity",
    status: RESERVATION_STATUS_MAP.DECLINED,
  },
  {
    key: "agencyPatientNotReachable",
    title: "Patient not reachable",
    status: RESERVATION_STATUS_MAP.DECLINED,
  },
  {
    key: "agencyOutOfArea",
    title: "Out of service area",
    status: RESERVATION_STATUS_MAP.DECLINED,
  },
];

export const PATIENT_REJECTION_CHOICES = [
  {
    key: "patientNotInterested",
    title: "Not interested in additional care",
    status: RESERVATION_STATUS_MAP.PATIENT_DECLINED,
  },
  {
    key: "patientPaymentIssue",
    title: "Payment (can’t afford or payor issue)",
    status: RESERVATION_STATUS_MAP.PATIENT_DECLINED,
  },
  {
    key: "patientDifferentProvider",
    title: "Chose a different home care provider",
    status: RESERVATION_STATUS_MAP.PATIENT_DECLINED,
  },
  {
    key: "patientFacility",
    title: "Went to a facility (ALF/ILF/SNF)",
    status: RESERVATION_STATUS_MAP.PATIENT_DECLINED,
  },
  {
    key: "patientCareUnneeded",
    title: "No Longer Needs Care",
    status: RESERVATION_STATUS_MAP.PATIENT_DECLINED,
  },
  {
    key: "patientDissatisfied",
    title: "Dissatisfied",
    status: RESERVATION_STATUS_MAP.PATIENT_DECLINED,
  },
];

export const SCHEDULE_VISIT_AFTER_WINDOW_CHOICES  = [
  // {
  //   key: "NO_SKILL_MATCH",
  //   title: " No skill match",
  // },
  // {
  //   key: "PATIENT_AVAILABILITY",
  //   title: "Patient availability",
  // },
  {
    key: "MEMBER_STILL_IN_HOSPITAL",
    title: "Member still in hospital",
  },
  {
    key: "MEMBER_IN_PAC_FACILITY",
    title: "Member in PAC facility (e.g., SNF)",
  },
  {
    key: "MEMBER_HAS_OTHER_CLINICAL_APPTS",
    title: "Member has other clinical appointments",
  },
  {
    key: "MEMBER_PREFERS_LATER_DATE",
    title: "Member prefers later date",
  },
  {
    key: "DISCHARGE_DATE_IS_UNDEFINED",
    title: "Discharge date is undefined/unknown",
  },
  {
    key: "LATE_NOTIFICATION_OF_ADMISSION",
    title: "Late notification of the hospital admission",
  },
  {
    key: "LATE_NOTIFICATION_OF_DISCHARGE",
    title: "Late notification of the discharge date",
  },
  {
    key: "NAVIGATOR_WAS_NOT_ASSIGNED_TO_MEMBER",
    title: "Navigator was not yet assigned to the member",
  },
  {
    key: "NAVIGATOR_DID_NOT_HAVE_THE_MEMBER_INFO",
    title: "Navigator did not have the member’s info yet",
  },
  {
    key: "WELLSKY_PROGRAM_LAUNCHED_AFTERWARDS",
    title: "WellSky program launched afterwards",
  },
  {
    key: "MEMBER_PREVIOUSLY_UNREACHABLE",
    title: "Member was previously unreachable for scheduling",
  },
  {
    key: "NO_PREFERRED_TIME_SLOTS_AVAILABLE",
    title: "No Visit Times Available",
  },
  {
    key: "SCHEDULING_WAS_INITIATED_LATER",
    title: "Scheduling Was Initiated Later",
  },
]

export const OPTUM_RESCHEDULE_REASONS = [
  {
    key: "MEMBER_STILL_IN_FACILITY",
    title: "Member still in facility"
  },
  {
    key: "MEMBER_REQUESTED_RESCEDULE",
    title: "Member requested reschedule"
  }
]

export const WELLSKY_OPS_RESCHEDULING_REASONS = [
  {
    key: "MEMBER_STILL_IN_FACILITY",
    title: "Member still in facility"
  },
  {
    key: "MEMBER_REQUESTED_RESCEDULE",
    title: "Member requested reschedule"
  },
  {
    key: "AGENCY_STAFFING",
    title: "Agency staffing"
  }
]

export const SDOH_RISK_CLASSIFICATION = [
  {title: "Low Risk", min: 0, max: 24},
  {title: "Early Risk", min: 25, max: 49},
  {title: "Rising Risk", min: 50, max: 74},
  {title: "High Risk", min: 75, max: 100},
]

export const INTERVENTIONS = {
  "NPE01": "NPE-Public Transit",
  "NPE02": "NPE-Violent/Property Crime",
  "NPE03": "NPE-Domestic Violence",
  "NPE04": "NPE-Maryland Overdose Rates",
  "NPE05": "NPE-Air Pollution",
  "NPE06": "NPE-EPA Removals",
  "NPE07": "NPE-Superfund Sites",
  "EDD01": "EDD-Education Level",
  "EDD02": "EDD-Education Mobility",
  "EDD03": "EDD-School District Funding",
  "EDD04": "EDD-Public Schools",
  "EDD05": "EDD-At risk afterschool meals",
  "EDD06": "EDD-Schools with free and reduced lunch",
  "EDD07": "EDD-Education Attainment/language",
  "EDD08": "EDD-Universties and Colleges",
  "CSC01": "CSC-Broadband Availability",
  "CSC02": "CSC-Recereation Centers",
  "CSC03": "CSC-Senior Centers",
  "CSC04": "CSC-Neighborhood Atlas",
  "ECS01": "ECS-Unemployment Rate",
  "ECS02": "ECS-Cost of Living",
  "ECS03": "ECS-Poverty Stats and Demo",
  "ECS04": "ECS-Household Income and Poverty",
  "ECS05": "ECS-Median Household Income",
  "ECS06": "ECS-Transportation and Poverty",
  "ECS07": "ECS-Foreclosure Notices Area",
  "HCS01": "HCS-Community Health Centers",
  "HCS02": "HCS-Hospitals",
  "HCS03": "HCS-Heart Disease",
  "HCS04":  "HCS-Diabetes",
  "HCS05": "HCS-Obesity",
  "FAC01": "FAC-Grocery Stores",
  "FAC02": "FAC-Farmers Markets",
  "FAC03": "FAC-Farm Stands",
  "FAC04": "FAC-Food Bank/Pantry",
  "FAC05": "FAC-WIC Vendors",
  "FAC06": "FAC-SNAP Programs",
}


export const DEFAULT_CUSTOM_DASHBOARD_WIDGETS = [
  {
    i: 'widget1',
    type: 'stats',
    name: 'widget1',
    x: 0,
    y: 0,
    w: 2,
    h: 1,
    settings: {
      label: 'Acute Emergency',
      count: '1',
      source: 'diversionalert',
      filterBy: 'AlertType',
      fiterValue: 'Acute Emergency',
    },
  },
  {
    i: 'widget2',
    type: 'stats',
    name: 'widget2',
    x: 2,
    y: 2,
    w: 2,
    h: 1,
    settings: {
      label: 'Acute Observation',
      count: '1',
      source: 'diversionalert',
      filterBy: 'AlertType',
      fiterValue: 'Acute Observation',
    },
  },
  {
    i: 'widget3',
    type: 'stats',
    name: 'widget3',
    x: 4,
    y: 4,
    w: 2,
    h: 1,
    settings: {
      label: 'Acute In-Patient',
      count: '1',
      source: 'diversionalert',
      filterBy: 'AlertType',
      fiterValue: 'Acute In-Patient',
    },
  },
  {
    i: 'widget4',
    type: 'stats',
    name: 'widget4',
    x: 6,
    y: 6,
    w: 2,
    h: 1,
    settings: {
      label: 'Flagged',
      count: '0',
      source: 'diversionalert',
      filterBy: 'Flag',
      fiterValue: 'true',
    },
  },
  {
    i: 'widget5',
    type: 'stats',
    name: 'widget5',
    x: 8,
    y: 8,
    w: 2,
    h: 1,
    settings: {
      label: 'In Progress',
      count: '2',
      source: 'diversionalert',
      filterBy: 'status',
      fiterValue: 'In-Progress',
    },
  },
  ,
  {
    i: 'widget6',
    type: 'stats',
    name: 'widget6',
    x: 10,
    y: 0,
    w: 2,
    h: 1,
    settings: {
      label: 'Last 48 Hours',
      count: '0',
      source: 'diversionalert',
      filterBy: 'admit_date',
      fiterValue: '48 Hours',
    },
  },
  {
    i: 'widget7',
    type: 'list',
    name: 'Diversion Alerts',
    x: 0,
    y: 0,
    w: 12,
    h: 4,
    settings: { source: 'diversionalert' },
  },
  {
    i: 'widget8',
    type: 'list',
    name: 'My Tasks',
    x: 0,
    y: 0,
    w: 12,
    h: 4,
    settings: { source: 'tasks' },
  }
];

export const NEW_CUSTOM_WIDGETS = [
  {
    id: '1',
    title: 'Task Assigned to me',
    type: 'list',
    settings: { source: 'tasks' },
    description: 'Allows team members to quickly view and manage work assigned to them.',
    icon: <CheckCircle1 fontSize="100px" />,
    handleChange: (id, selected) => {},
  },
  {
    id: '2',
    settings: { source: 'fax' },
    title: 'Inbound & Outbound Fax',
    type: 'list',
    description: 'Allows team members to quickly view the inbound and outbound faxes.',
    icon: <FaxOutlined fontSize="100px" />,
    handleChange: (id, selected) => {},
  },
  {
    id: '3',
    settings: { source: 'diversionalert' },
    title: 'Diversion Alerts',
    type: 'list',
    description: 'Allows team members to quickly view the Diversion Alerts.',
    icon: <Alerts2 fontSize="100px" />,
    handleChange: (id, selected) => {},
  },
];

export const PROSPECT_PAGE_DETAILS = {
  "pages": [
      {
          "title": "Prospect Profile",
          "previousButton": "Previous",
          "nextButton": "has(inputArgs) && has(inputArgs.patientId) || has(pageDataStore.UpdatePatientStep1) && has(pageDataStore.UpdatePatientStep1.createPatient.patient) && has(pageDataStore.UpdatePatientStep1.createPatient.patient.id) ? 'Next' : 'Create Prospect'",
          "customFormsTemplateId": "GLOBAL_PATIENT_FORM",
          "customFormCreateTransform": {
              "'patient_profile_input_public_care_coordination_notes'": "has(q_0.getPatient.notes) && size(q_0.getPatient.notes) > 0 ? q_0.getPatient.notes: ''",
              "'patient_profile_input_private_care_coordination_notes'": "has(q_0.getPatient.privateNotes) && size(q_0.getPatient.privateNotes) > 0 ? q_0.getPatient.privateNotes: ''",
              "'patient_profile'": {
                  "'select_state'": "has(q_0.getPatient.state) && size(q_0.getPatient.state) > 0 ? q_0.getPatient.state: ''",
                  "'input_city'": "has(q_0.getPatient.city) && size(q_0.getPatient.city) > 0 ? q_0.getPatient.city: ''",
                  "'input_first_name'": "has(q_0.getPatient.firstName) && size(q_0.getPatient.firstName) > 0 ? q_0.getPatient.firstName: ''",
                  "'date_dob'": "has(q_0.getPatient.dob) && size(q_0.getPatient.dob) > 0 ? q_0.getPatient.dob: ''",
                  "'input_last_name'": "has(q_0.getPatient.lastName) && size(q_0.getPatient.lastName) > 0 ? q_0.getPatient.lastName: ''",
                  "'select_tags'": "has(q_0.getPatient.tags) && size(q_0.getPatient.tags) > 0 ? q_0.getPatient.tags: ''",
                  "'input_ssn'": "has(q_0.getPatient.ssn) ? q_0.getPatient.ssn: ''",
                  "'input_number_ssn'": "has(q_0.getPatient.ssn) ? q_0.getPatient.ssn: ''",
                  "'select_gender'": "has(q_0.getPatient.gender) && size(q_0.getPatient.gender) > 0 ? q_0.getPatient.gender: ''",
                  "'input_address'": "has(q_0.getPatient.address1) && size(q_0.getPatient.address1) > 0 ? q_0.getPatient.address1: ''",
                  "'input_zip_code'": "has(q_0.getPatient.zipCode) && size(q_0.getPatient.zipCode) > 0 ? q_0.getPatient.zipCode: ''",
                  "'input_middle_name'": "has(q_0.getPatient.middleName) && size(q_0.getPatient.middleName) > 0 ? q_0.getPatient.middleName: ''",
                  "'input_address2'": "has(q_0.getPatient.address2) && size(q_0.getPatient.address2) > 0 ? q_0.getPatient.address2: ''",
                  "'timezone_list'": "has(q_1.listTimeZones) && q_1.listTimeZones.map(d, {'timezone_list_tz': d})",
                  "'select_patient_timezone'": "has(q_0.getPatient.timezone) && size(q_0.getPatient.timezone) > 0 ? q_0.getPatient.timezone : ''",
                  "'section_phone_number'": {
                      "'select_2077'": "has(q_0.getPatient.primaryPhoneNumber) && size(q_0.getPatient.primaryPhoneNumber) > 0 ? q_0.getPatient.primaryPhoneNumber : ''",
                      "'section_phone_table'": "(has(q_0.getPatient.telecom) && size(q_0.getPatient.telecom)>0 ? q_0.getPatient.telecom:[]).map(t, {'input_phone': size(t) > 0 && has(t.value) ? t.value : '','select_phone_type':size(t) > 0 && has(t.use) ? (t.system == 'FAX'? 'FAX': t.use): ''})"
                  },
                  "'input_mrn'": "has(q_0.getPatient.medicalRecordNumber) && size(q_0.getPatient.medicalRecordNumber) > 0 ? q_0.getPatient.medicalRecordNumber: ''",
                  "'input_medicare_id'": "has(q_0.getPatient.medicareId) && size(q_0.getPatient.medicareId) > 0 ? q_0.getPatient.medicareId: ''",
                  "'date_start_of_care'": "has(q_0.getPatient.startOfCare) && size(q_0.getPatient.startOfCare) > 0 ? q_0.getPatient.startOfCare: ''",
                  "'input_email'": "has(q_0.getPatient.email) && size(q_0.getPatient.email) > 0 ? q_0.getPatient.email: ''"
              }
          },
          "getDataQueries": [
              {
                  "name": "GetPatientDetailsStep1",
                  "operation": "getPatient",
                  "skipIfNotValidOperator": "or",
                  "skipIfNotValid": [
                      {
                          "variable": "inputArgs.patientType",
                          "value": "UPDATE"
                      },
                      {
                          "variable": "_pageDataStore.UpdatePatientStep1.createPatient.patient.id"
                      },
                      {
                          "variable": "_pageDataStore.UpdatePatientStep2.updatePatient.id"
                      }
                  ],
                  "transformData": true,
                  "queryVariables": {
                      "'organizationId'": "has(inputArgs) && has(inputArgs.organizationId) && size(inputArgs.organizationId) > 0 ? inputArgs.organizationId : ''",
                      "'id'": "has(inputArgs) && has(inputArgs.patientId) && size(inputArgs.patientId) > 0 ? inputArgs.patientId : has(_pageDataStore.UpdatePatientStep1.createPatient.patient.id) ? _pageDataStore.UpdatePatientStep1.createPatient.patient.id : _pageDataStore.UpdatePatientStep2.updatePatient.id"
                  },
                  "query": "query getPatient($organizationId: ID!, $id: ID!) { getPatient(organizationId: $organizationId, id: $id) { firstName middleName lastName zipCode ssn address1 address2 city state country dob gender medicalRecordNumber email notes privateNotes medicareId startOfCare primaryPhoneNumber telecom {system value use rank} timezone(assignedTimezoneOnly:true)}  }",
                  "requestType": "GRAPHQL"
              },
              {
                  "name": "ListTimezones",
                  "operation": "listTimeZones",
                  "queryVariables": {},
                  "query": "query listTimeZones { listTimeZones }"
              }
          ],
          "updateQuery": [
              {
                  "name": "UpdatePatientStep1",
                  "operation": "createPatient",
                  "preRequisite": "patient_profile.section_phone_number.section_phone_table",
                  "errorMessage": "At least one phone number is mandatory",
                  "skipIfNotValidOperator": "and",
                  "skipIfNotValid": [
                      {
                          "variable": "inputArgs.patientType",
                          "value": "CREATE"
                      },
                      {
                          "variable": "_pageDataStore.UpdatePatientStep1.createPatient.patient.id",
                          "value": null
                      },
                      {
                          "variable": "_pageDataStore.UpdatePatientStep2.updatePatient.id",
                          "value": null
                      }
                  ],
                  "queryVariables": {
                      "'input'": {
                          "'organizationId'": "has(inputArgs) && has(inputArgs.organizationId) && size(inputArgs.organizationId) > 0 ? inputArgs.organizationId : ''",
                          "'middleName'": "has(patient_profile.input_middle_name) && size(patient_profile.input_middle_name) > 0 ? patient_profile.input_middle_name : ''",
                          "'firstName'": "has(patient_profile.input_first_name) && size(patient_profile.input_first_name) > 0 ? patient_profile.input_first_name : ''",
                          "'lastName'": "has(patient_profile.input_last_name) && size(patient_profile.input_last_name) > 0 ? patient_profile.input_last_name : ''",
                          "'address1'": "has(patient_profile.input_address) && size(patient_profile.input_address) > 0 ? patient_profile.input_address : ''",
                          "'address2'": "has(patient_profile.input_address2) && size(patient_profile.input_address2) > 0 ? patient_profile.input_address2 : ''",
                          "'city'": "has(patient_profile.input_city) && size(patient_profile.input_city) > 0 ? patient_profile.input_city : ''",
                          "'state'": "patient_profile.select_state",
                          "'country'": "has(patient_profile.select_country) && size(patient_profile.select_country) > 0 ? patient_profile.select_country : ''",
                          "'zipCode'": "patient_profile.input_zip_code",
                          "'ssn'": "has(patient_profile.input_number_ssn) ? string(patient_profile.input_number_ssn) : ''",
                          "'dob'": "has(patient_profile.date_dob) && size(patient_profile.date_dob) > 0 ? patient_profile.date_dob : ''",
                          "'gender'": "has(patient_profile.select_gender) && size(patient_profile.select_gender) > 0 ? patient_profile.select_gender : ''",
                          "'medicareId'": "has(patient_profile.input_medicare_id) && size(patient_profile.input_medicare_id) > 0 ? patient_profile.input_medicare_id : ''",
                          "'medicalRecordNumber'": "has(patient_profile.input_mrn) && size(patient_profile.input_mrn) > 0 ? patient_profile.input_mrn : ''",
                          "'startOfCare'": "has(patient_profile.date_start_of_care) && size(patient_profile.date_start_of_care) > 0 ? patient_profile.date_start_of_care : ''",
                          "'email'": "has(patient_profile.input_email) && size(patient_profile.input_email) > 0 ? patient_profile.input_email : ''",
                          "'notes'": "has(patient_profile_input_public_care_coordination_notes) && size(patient_profile_input_public_care_coordination_notes) > 0 ? patient_profile_input_public_care_coordination_notes : ''",
                          "'privateNotes'": "has(patient_profile_input_private_care_coordination_notes) && size(patient_profile_input_private_care_coordination_notes) > 0 ? patient_profile_input_private_care_coordination_notes : ''",
                          "'telecom'": "(has(patient_profile.section_phone_number.section_phone_table) && size(patient_profile.section_phone_number.section_phone_table) > 0 ? patient_profile.section_phone_number.section_phone_table : []).map(p, {'system': p.select_phone_type == 'FAX'? 'FAX': 'PHONE', 'use': p.select_phone_type == 'FAX'? 'OTHER': p.select_phone_type, 'value': p.input_phone})",
                          "'timezone'": "patient_profile.select_patient_timezone"
                      }
                  },
                  "query": "mutation createPatient($input: CreatePatientInput!) { createPatient(input:$input) { patient { id } }}",
                  "requestType": "GRAPHQL"
              },
              {
                  "name": "UpdatePatientStep2",
                  "operation": "updatePatient",
                  "preRequisite": "patient_profile.section_phone_number.section_phone_table",
                  "errorMessage": "At least one phone number is mandatory",
                  "skipIfNotValidOperator": "or",
                  "skipIfNotValid": [
                      {
                          "variable": "inputArgs.patientType",
                          "value": "UPDATE"
                      },
                      {
                          "variable": "_pageDataStore.UpdatePatientStep1.createPatient.patient.id"
                      },
                      {
                          "variable": "_pageDataStore.UpdatePatientStep2.updatePatient.id"
                      }
                  ],
                  "queryVariables": {
                      "'input'": {
                          "'organizationId'": "has(inputArgs) && has(inputArgs.organizationId) && size(inputArgs.organizationId) > 0 ? inputArgs.organizationId : ''",
                          "'id'": "has(inputArgs) && has(inputArgs.patientId) && size(inputArgs.patientId) > 0 ? inputArgs.patientId : has(_pageDataStore.UpdatePatientStep1) && has(_pageDataStore.UpdatePatientStep1.createPatient.patient.id) ? _pageDataStore.UpdatePatientStep1.createPatient.patient.id : has(_pageDataStore.UpdatePatientStep2) && has(_pageDataStore.UpdatePatientStep2.updatePatient.id) ? _pageDataStore.UpdatePatientStep2.updatePatient.id : ''",
                          "'middleName'": "has(patient_profile.input_middle_name) && size(patient_profile.input_middle_name) > 0 ? patient_profile.input_middle_name : ''",
                          "'firstName'": "has(patient_profile.input_first_name) && size(patient_profile.input_first_name) > 0 ? patient_profile.input_first_name : ''",
                          "'lastName'": "has(patient_profile.input_last_name) && size(patient_profile.input_last_name) > 0 ? patient_profile.input_last_name : ''",
                          "'address1'": "has(patient_profile.input_address) && size(patient_profile.input_address) > 0 ? patient_profile.input_address : ''",
                          "'address2'": "has(patient_profile.input_address2) && size(patient_profile.input_address2) > 0 ? patient_profile.input_address2 : ''",
                          "'city'": "has(patient_profile.input_city) && size(patient_profile.input_city) > 0 ? patient_profile.input_city : ''",
                          "'state'": "patient_profile.select_state",
                          "'country'": "has(patient_profile.select_country) && size(patient_profile.select_country) > 0 ? patient_profile.select_country : ''",
                          "'zipCode'": "patient_profile.input_zip_code",
                          "'ssn'": "has(patient_profile.input_number_ssn) ? string(patient_profile.input_number_ssn) : ''",
                          "'dob'": "has(patient_profile.date_dob) && size(patient_profile.date_dob) > 0 ? patient_profile.date_dob : ''",
                          "'gender'": "has(patient_profile.select_gender) && size(patient_profile.select_gender) > 0 ? patient_profile.select_gender : ''",
                          "'medicareId'": "has(patient_profile.input_medicare_id) && size(patient_profile.input_medicare_id) > 0 ? patient_profile.input_medicare_id : ''",
                          "'medicalRecordNumber'": "has(patient_profile.input_mrn) && size(patient_profile.input_mrn) > 0 ? patient_profile.input_mrn : ''",
                          "'startOfCare'": "has(patient_profile.date_start_of_care) && size(patient_profile.date_start_of_care) > 0 ? patient_profile.date_start_of_care : ''",
                          "'email'": "has(patient_profile.input_email) && size(patient_profile.input_email) > 0 ? patient_profile.input_email : ''",
                          "'notes'": "has(patient_profile_input_public_care_coordination_notes) && size(patient_profile_input_public_care_coordination_notes) > 0 ? patient_profile_input_public_care_coordination_notes : ''",
                          "'privateNotes'": "has(patient_profile_input_private_care_coordination_notes) && size(patient_profile_input_private_care_coordination_notes) > 0 ? patient_profile_input_private_care_coordination_notes : ''",
                          "'telecom'": "(has(patient_profile.section_phone_number.section_phone_table) && size(patient_profile.section_phone_number.section_phone_table) > 0 ? patient_profile.section_phone_number.section_phone_table : []).map(p, {'system': p.select_phone_type == 'FAX'? 'FAX': 'PHONE', 'use': p.select_phone_type == 'FAX'? 'OTHER': p.select_phone_type, 'value': p.input_phone})",
                          "'timezone'": "patient_profile.select_patient_timezone"
                      }
                  },
                  "query": "mutation updatePatient($input: UpdatePatientInput!) { updatePatient(input:$input) { id }}",
                  "requestType": "GRAPHQL"
              }
          ]
      },
      {
          "title": "Contacts",
          "previousButton": "Previous",
          "nextButton": "Next",
          "customFormsTemplateId": "GLOBAL_PATIENT_CONTACTS",
          "customFormCreateTransform": {
              "'section_contacts'": "has(q_0.getRelatedPersonsForPatient.items) && size(q_0.getRelatedPersonsForPatient.items) > 0 ? q_0.getRelatedPersonsForPatient.items.map(it, {'readonly_related_person_id': it.id ,'select_relation': has(it.relationship) && size(it.relationship) > 0 ? it.relationship[0].code : '','input_firstname': it.name[0].given[0],'input_lastname': it.name[0].family,'input_address1': has(it.address) && size(it.address) > 0 && size(it.address[0].line) > 0 ? it.address[0].line[0] : '','input_address2': has(it.address) && size(it.address) > 0 && size(it.address[0].line) > 1 ? it.address[0].line[1] : '','input_city': has(it.address) && size(it.address) > 0 && has(it.address[0].city) && size(it.address[0].city) > 0 ? it.address[0].city : '','select_state': has(it.address) && size(it.address) > 0 && has(it.address[0].state) && size(it.address[0].state) > 0 ? it.address[0].state : '','address_zip': has(it.address) && size(it.address) > 0 && has(it.address[0].postalCode) && size(it.address[0].postalCode) > 0 ? it.address[0].postalCode : '','input_homephone': size(((has(it['telecom']) && size(it['telecom']) > 0 ? it['telecom'] : [{'use' : 'HOME', 'system' : 'PHONE', 'value' : ''}]).filter(y, has(y) && has(y['use']) && y['use'] == 'HOME' && has(y['system']) && y['system'] == 'PHONE' && y['value'] != ''))) > 0 ? ((has(it['telecom']) && size(it['telecom']) > 0 ? it['telecom'] : [{'use' : 'HOME', 'system' : 'PHONE', 'value' : ''}]).filter(y, has(y) && has(y['use']) && y['use'] == 'HOME' && has(y['system']) && y['system'] == 'PHONE' && y['value'] != ''))[0]['value'] : '','input_mobilephone': size(((has(it['telecom']) && size(it['telecom']) > 0 ? it['telecom'] : [{'use' : 'MOBILE', 'system' : 'PHONE', 'value' : ''}]).filter(y, has(y) && has(y['use']) && y['use'] == 'MOBILE' && has(y['system']) && y['system'] == 'PHONE' && y['value'] != ''))) > 0 ? ((has(it['telecom']) && size(it['telecom']) > 0 ? it['telecom'] : [{'use' : 'MOBILE', 'system' : 'PHONE', 'value' : ''}]).filter(y, has(y) && has(y['use']) && y['use'] == 'MOBILE' && has(y['system']) && y['system'] == 'PHONE' && y['value'] != ''))[0]['value'] : '','input_workphone': size(((has(it['telecom']) && size(it['telecom']) > 0 ? it['telecom'] : [{'use' : 'WORK', 'system' : 'PHONE', 'value' : ''}]).filter(y, has(y) && has(y['use']) && y['use'] == 'WORK' && has(y['system']) && y['system'] == 'PHONE' && y['value'] != ''))) > 0 ? ((has(it['telecom']) && size(it['telecom']) > 0 ? it['telecom'] : [{'use' : 'WORK', 'system' : 'PHONE', 'value' : ''}]).filter(y, has(y) && has(y['use']) && y['use'] == 'WORK' && has(y['system']) && y['system'] == 'PHONE' && y['value'] != ''))[0]['value'] : '','input_fax': size(((has(it['telecom']) && size(it['telecom']) > 0 ? it['telecom'] : [{'system' : 'FAX', 'value' : ''}]).filter(y, has(y) && has(y['system']) && y['system'] == 'FAX' && y['value'] != ''))) > 0 ? ((has(it['telecom']) && size(it['telecom']) > 0 ? it['telecom'] : [{'system' : 'FAX', 'value' : ''}]).filter(y, has(y) && has(y['system']) && y['system'] == 'FAX' && y['value'] != ''))[0]['value'] : '','input_email': size(((has(it['telecom']) && size(it['telecom']) > 0 ? it['telecom'] : [{'system' : 'EMAIL', 'value' : ''}]).filter(y, has(y) && has(y['system']) && y['system'] == 'EMAIL' && y['value'] != ''))) > 0 ? ((has(it['telecom']) && size(it['telecom']) > 0 ? it['telecom'] : [{ 'system' : 'EMAIL', 'value' : ''}]).filter(y, has(y) && has(y['system']) && y['system'] == 'EMAIL' && y['value'] != ''))[0]['value'] : '' }): []"
          },
          "getDataQueries": [
              {
                  "name": "GetPatientDetailsStep2",
                  "operation": "getRelatedPersonsForPatient",
                  "transformData": true,
                  "queryVariables": {
                      "'organizationId'": "has(inputArgs) && has(inputArgs.organizationId) && size(inputArgs.organizationId) > 0 ? inputArgs.organizationId : ''",
                      "'patientId'": "has(inputArgs) && has(inputArgs.patientId) && size(inputArgs.patientId) > 0 ? inputArgs.patientId : has(_pageDataStore.UpdatePatientStep1.createPatient.patient.id) ? _pageDataStore.UpdatePatientStep1.createPatient.patient.id : has(_pageDataStore.UpdatePatientStep2.updatePatient.id) ? _pageDataStore.UpdatePatientStep2.updatePatient.id : ''"
                  },
                  "query": "query getRelatedPersonsForPatient($organizationId: ID!, $patientId: ID!) { getRelatedPersonsForPatient(organizationId: $organizationId, patientId: $patientId) { total items { id relationship {code} name { given family } address { line city state postalCode } telecom { use value system }}}}",
                  "requestType": "GRAPHQL"
              }
          ],
          "updateQuery": [
              {
                  "name": "UpdatePatientStep3",
                  "operation": "updatePatient",
                  "queryVariables": {
                      "'organizationId'": "inputArgs.organizationId",
                      "'patientId'": "has(inputArgs) && has(inputArgs.patientId) && size(inputArgs.patientId) > 0 ? inputArgs.patientId : has(_pageDataStore.UpdatePatientStep1.createPatient.patient.id) ? _pageDataStore.UpdatePatientStep1.createPatient.patient.id : _pageDataStore.UpdatePatientStep2.updatePatient.id",
                      "'forceDeleteRemaining'": true,
                      "'persons'": "(has(section_contacts) && size(section_contacts) > 0 ? section_contacts : []).map(c, {'patientId': has(inputArgs) && has(inputArgs.patientId) && size(inputArgs.patientId) > 0 ? inputArgs.patientId : has(_pageDataStore.UpdatePatientStep1.createPatient.patient.id) ? _pageDataStore.UpdatePatientStep1.createPatient.patient.id : _pageDataStore.UpdatePatientStep2.updatePatient.id,'id': has(c.readonly_related_person_id) && size(c.readonly_related_person_id) > 0 ? c.readonly_related_person_id : null,'name': [{'given':[c.input_firstname], 'family':c.input_lastname}],'relationship': [{ 'code': c.select_relation}],'address': [{'line': [has(c.input_address1) && size(c.input_address1) > 0 ? c.input_address1 : '', has(c.input_address2) && size(c.input_address2) > 0 ? c.input_address2 : ''],'city': has(c.input_city) && size(c.input_city) > 0 ? c.input_city: '','state': has(c.select_state) && size(c.select_state) > 0 ? c.select_state : '','postalCode': has(c.address_zip) && size(c.address_zip) > 0 ? c.address_zip : ''}],'telecom': [{'system':'PHONE', 'use':'HOME', 'value': has(c.input_homephone) && size(c.input_homephone) > 0 ? c.input_homephone : ''},{'system':'PHONE', 'use':'WORK', 'value': has(c.input_workphone) && size(c.input_workphone) > 0 ? c.input_workphone : ''},{'system':'PHONE', 'use':'MOBILE', 'value': has(c.input_mobilephone) && size(c.input_mobilephone) > 0 ? c.input_mobilephone : ''},{'system':'FAX', 'use':'WORK', 'value': has(c.input_fax) && size(c.input_fax) > 0 ? c.input_fax : ''},{'system':'EMAIL', 'use':'WORK', 'value': has(c.input_email) && size(c.input_email) > 0 ? c.input_email : ''}]})"
                  },
                  "query": "mutation createOrModifyMultipleRelatedPersons($patientId: ID!, $organizationId: ID!, $persons: [CreateRelatedPersonInput!], $forceDeleteRemaining: Boolean) { createOrModifyMultipleRelatedPersons(patientId: $patientId, organizationId: $organizationId, persons: $persons, forceDeleteRemaining: $forceDeleteRemaining) }",
                  "requestType": "GRAPHQL"
              }
          ],
          "updatesOnPreviousPress": [
              "UpdatePatientStep3"
          ]
      }
  ]
};